import { memo } from 'react'
import cn from 'classnames'

import { BaseItem, RenderItem } from './types'
import styles from './dropdown-item.module.scss'

type DropdownItemProps<T extends BaseItem> = {
  id: string

  item: T

  active: boolean

  selected: boolean

  className?: string

  itemHeight?: number

  renderItem?: RenderItem<T>

  onMouseEnter: () => void

  onClick: () => void
}

function DropdownItemComponent<T extends BaseItem>({
  id,
  item,
  active,
  selected,
  className,
  itemHeight = 30,
  renderItem,
  onMouseEnter,
  onClick,
}: DropdownItemProps<T>) {
  return (
    <div
      id={id}
      role="option"
      aria-selected={selected}
      className={cn(styles.item, className)}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
    >
      {renderItem ? renderItem(item, { active, selected, itemHeight }) : item.title}
    </div>
  )
}

export const DropdownItem = memo(DropdownItemComponent) as typeof DropdownItemComponent
